(() => {
  const selector = '.bq-add,.bq-inc,[data-gt-add],.bah-pick-add,[data-pdp-upadd]';
  const bag = '<svg viewBox="0 0 16 18" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><path d="M3 5.5h10l1 10H2l1-10Z"/><path d="M5 5.5V4a3 3 0 0 1 6 0v1.5"/></svg>';
  let queued = false;
  const observed = new WeakSet();
  const resize = new ResizeObserver(() => queue());
  function positionIcons() {
    document.querySelectorAll(selector).forEach(button => {
      const card = button.closest('.bc-card,.ar-cell,.november-hub__product,.array-last-chance__product,.dh-cell,.gt-card,.su-card,.kb2-item,.pdp-up,.bah-pick');
      if (!card) return;
      let image = card.querySelector('.bc-media,.ar-shot,.november-hub__product-link>img,.array-last-chance__product-link>img,.dh-shot,.su-shot,.kb2-shot,.pdp-up-img,img');
      const face = button.closest('.gt-mface');
      if (face) {
        const index = [...card.querySelectorAll('.gt-mface')].indexOf(face);
        image = card.querySelectorAll('.gt-face')[index];
      }
      const parent = button.offsetParent;
      if (!image || !parent) return;
      [image, parent].forEach(element => {
        if (!observed.has(element)) { observed.add(element); resize.observe(element); }
      });
      const box = image.getBoundingClientRect(), origin = parent.getBoundingClientRect();
      if (!box.width || !box.height) return;
      button.style.setProperty('--bq-icon-top', `${box.bottom - origin.top + parent.scrollTop - parent.clientTop - 52}px`);
      button.style.setProperty('--bq-icon-left', `${box.left - origin.left + parent.scrollLeft - parent.clientLeft + 8}px`);
    });
  }
  function paint() {
    queued = false;
    const labels = document.querySelector('[data-bq-labels]')?.dataset;
    if (!labels) return;
    document.querySelectorAll(selector).forEach(button => {
      if (!button.classList.contains('bq-label-button')) button.classList.add('bq-label-button');
      if (button.classList.contains('bq-add') && !button.classList.contains('bq-add--label')) button.classList.add('bq-add--label');
      const text = button.disabled ? labels.soldOut : (button.classList.contains('is-busy') || button.closest('.bq-step.is-busy')) ? labels.adding : button.classList.contains('is-done') ? labels.added : labels.add;
      if (button.dataset.actionText === text && button.querySelector('span')?.textContent === text) return;
      button.dataset.actionText = text;
      button.title = text;
      button.innerHTML = bag;
      const label = document.createElement('span');
      label.textContent = text;
      button.append(label);
    });
    positionIcons();
  }
  const queue = () => { if (!queued) { queued = true; requestAnimationFrame(paint); } };
  document.addEventListener('click', event => {
    const swatch = event.target.closest('.bc-sw,.ar-sw,.bsw-dot');
    if (!swatch) return;
    const card = swatch.closest('.gt-mface,.bc-card,.ar-cell,.november-hub__product,.array-last-chance__product,.dh-cell,.su-card,.kb2-item,.pdp-up');
    if (!card) return;
    const unavailable = swatch.classList.contains('array-swatch-unavailable');
    card.querySelectorAll(selector).forEach(button => {
      if (!button.classList.contains('is-busy') && !button.closest('.is-busy')) button.disabled = unavailable;
      const labels = document.querySelector('[data-bq-labels]')?.dataset;
      if (labels) button.setAttribute('aria-label', unavailable ? labels.soldOut : labels.add);
    });
    queue();
  }, true);
  paint();
  window.addEventListener('resize', queue, { passive: true });
  new MutationObserver(queue).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'disabled'] });
})();
